<div class="policies-card" *ngIf="!modalOnly">
  <div class="policies-header">
    <div class="policies-title">{{ title }}</div>
    <div class="policies-subtitle">
      {{ confirmationPhaseEnabled ? 'MARCA LAS CONFIRMACIONES FINALES PARA CONTINUAR.' : 'LEE Y ACEPTA LOS DOCUMENTOS PARA DESBLOQUEAR LAS CONFIRMACIONES.' }}
    </div>
  </div>

  <div class="policies-loading" *ngIf="loading">
    CARGANDO POLITICAS...
  </div>

  <div class="policies-empty" *ngIf="!loading && !primaryPolicy && linkedPolicies.length === 0">
    NO HAY POLITICAS ACTIVAS DISPONIBLES.
  </div>

  <div class="policies-primary-copy policies-primary-copy--waiting" *ngIf="!loading && confirmationItems.length > 0 && !confirmationPhaseEnabled">
    <div class="primary-copy-intro">
      LAS CONFIRMACIONES SE HABILITAN AL TERMINAR LA LECTURA.
    </div>
  </div>

  <div class="policies-primary-copy" *ngIf="!loading && primaryPolicy && confirmationPhaseEnabled">
    <div class="primary-copy-intro" *ngIf="primaryIntro">{{ primaryIntro }}</div>

    <div class="confirmations-list" *ngIf="confirmationItems.length">
      <label
        class="confirmation-item"
        *ngFor="let item of confirmationItems"
        [class.accepted]="isConfirmationAccepted(item)">
        <input
          class="confirmation-input"
          type="checkbox"
          [checked]="isConfirmationAccepted(item)"
          (change)="onConfirmationToggle(item, $event)" />

        <span class="confirmation-check" [class.checked]="isConfirmationAccepted(item)">
          <mat-icon>{{ isConfirmationAccepted(item) ? 'check' : 'done' }}</mat-icon>
        </span>

        <span class="confirmation-copy">
          <span class="confirmation-text">{{ item.text }}</span>

          <button
            class="confirmation-link"
            type="button"
            *ngIf="isReadingConfirmation(item)"
            (click)="openConfirmationDocument(item, $event)">
            VER DOCUMENTO
          </button>
        </span>
      </label>
    </div>

    <div class="confirmation-error" *ngIf="showConfirmationError && !allConfirmationItemsConfirmed">
      DEBES MARCAR TODAS LAS CONFIRMACIONES PARA CONTINUAR.
    </div>
  </div>

  <div class="policies-status" *ngIf="!loading && linkedPolicies.length > 0">
    <div class="status-pill" [class.complete]="allRequiredAccepted || documentsReadyForConfirmation">
      <mat-icon>{{ allRequiredAccepted || documentsReadyForConfirmation ? 'check_circle' : 'pending' }}</mat-icon>
      {{ allRequiredAccepted ? 'DOCUMENTOS Y CONFIRMACIONES COMPLETOS' : (documentsReadyForConfirmation ? 'LECTURA COMPLETA, FALTA CONFIRMAR CHECKBOXES' : 'FALTA LEER Y ACEPTAR LOS DOCUMENTOS') }}
    </div>

    <button mat-stroked-button color="primary" type="button" (click)="openConsentModal()">
      {{ documentsReadyForConfirmation ? 'REVISAR POLITICAS' : 'LEER Y ACEPTAR POLITICAS' }}
    </button>
  </div>
</div>

<div class="policies-modal-backdrop" *ngIf="showModal">
  <div class="policies-modal" role="dialog" aria-modal="true">
    <div class="modal-header">
      <div>
        <div class="modal-title">
          {{ viewerPolicy ? viewerPolicy.titulo : 'AUTORIZACION DE POLITICAS' }}
        </div>
        <div class="modal-subtitle" *ngIf="!viewerPolicy">
          REVISA LOS DOCUMENTOS COMPLETOS Y ACEPTALOS DESDE CADA LECTURA.
        </div>
        <div class="modal-subtitle" *ngIf="viewerPolicy">
          DESPLAZATE HASTA EL FINAL DEL DOCUMENTO PARA PODER ACEPTARLO.
        </div>
      </div>

      <button class="icon-close" type="button" (click)="closeConsentModal(false)">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-body" *ngIf="!viewerPolicy">
      <div class="primary-policy" *ngIf="primaryPolicy">
        <div class="primary-content" [innerHTML]="primaryPolicy.contenido"></div>
      </div>

      <div class="documents-list" *ngIf="!confirmationPhaseEnabled">
        <div class="document-row" *ngFor="let policy of linkedPolicies">
          <div class="document-copy">
            <button class="policy-link" type="button" (click)="openDocument(policy)">
              {{ policy.titulo }}
            </button>
            <div class="document-edition" *ngIf="policy.edicion">ED. {{ policy.edicion }}</div>
          </div>

          <div class="document-status" [class.accepted]="isAccepted(policy.idPoliticaPrivacidad)">
            <mat-icon>{{ isAccepted(policy.idPoliticaPrivacidad) ? 'check_circle' : 'menu_book' }}</mat-icon>
            {{ isAccepted(policy.idPoliticaPrivacidad) ? 'ACEPTADO' : 'PENDIENTE' }}
          </div>
        </div>
      </div>

      <div class="policies-primary-copy" *ngIf="confirmationPhaseEnabled">
        <div class="primary-copy-intro" *ngIf="primaryIntro">{{ primaryIntro }}</div>

        <div class="confirmations-list" *ngIf="confirmationItems.length">
          <label
            class="confirmation-item"
            *ngFor="let item of confirmationItems"
            [class.accepted]="isConfirmationAccepted(item)">
            <input
              class="confirmation-input"
              type="checkbox"
              [checked]="isConfirmationAccepted(item)"
              (change)="onConfirmationToggle(item, $event)" />

            <span class="confirmation-check" [class.checked]="isConfirmationAccepted(item)">
              <mat-icon>{{ isConfirmationAccepted(item) ? 'check' : 'done' }}</mat-icon>
            </span>

            <span class="confirmation-copy">
              <span class="confirmation-text">{{ item.text }}</span>

              <button
                class="confirmation-link"
                type="button"
                *ngIf="isReadingConfirmation(item)"
                (click)="openConfirmationDocument(item, $event)">
                VER DOCUMENTO
              </button>
            </span>
          </label>
        </div>

        <div class="confirmation-error" *ngIf="showConfirmationError && !allConfirmationItemsConfirmed">
          DEBES MARCAR TODAS LAS CONFIRMACIONES PARA CONTINUAR.
        </div>
      </div>
    </div>

    <div class="modal-body" *ngIf="viewerPolicy">
      <button class="back-link" type="button" (click)="backToSummary()">
        <mat-icon>arrow_back</mat-icon>
        VOLVER AL RESUMEN
      </button>

      <div class="document-scroll" (scroll)="onDocumentScroll($event)" [innerHTML]="viewerPolicy.contenido"></div>

      <div class="scroll-hint" [class.ready]="viewerReachedEnd">
        <mat-icon>{{ viewerReachedEnd ? 'task_alt' : 'south' }}</mat-icon>
        {{ viewerReachedEnd ? 'YA PUEDES ACEPTAR ESTE DOCUMENTO' : 'DESPLAZATE HASTA EL FINAL PARA HABILITAR LA ACEPTACION' }}
      </div>
    </div>

    <div class="modal-actions">
      <button mat-button type="button" (click)="closeConsentModal(false)" *ngIf="!viewerPolicy">
        CANCELAR
      </button>

      <button mat-flat-button color="primary" type="button" (click)="finishConsentFlow()" [disabled]="!documentsReadyForConfirmation" *ngIf="!viewerPolicy && !confirmationPhaseEnabled">
        CONTINUAR A CONFIRMACIONES
      </button>

      <button mat-flat-button color="primary" type="button" (click)="completeConsentFlow()" [disabled]="!allRequiredAccepted" *ngIf="!viewerPolicy && confirmationPhaseEnabled">
        ACEPTAR Y CONTINUAR
      </button>

      <button mat-button type="button" (click)="backToSummary()" *ngIf="viewerPolicy">
        VOLVER
      </button>

      <button mat-flat-button color="primary" type="button" (click)="acceptViewedPolicy()" [disabled]="!viewerReachedEnd" *ngIf="viewerPolicy">
        HE LEIDO Y ACEPTO
      </button>
    </div>
  </div>
</div>
